
const Tickets = () => {
    return null;
}

export default Tickets;
